import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useEffect } from 'react';
import { sendGlobalTrackingThunk } from '../../../redux/core/thunks.js';
import { useAppDispatch } from '../../../redux/hooks.js';
import { trackSuccessResetPassword } from '../../../tracking/featureSpecific/resetPassword/index.js';
import { INITIAL_TRACKING_DELAY } from '../../../tracking/constants.js';
export const PasswordResetSuccessAlert = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        setTimeout(() => {
            dispatch(sendGlobalTrackingThunk(trackSuccessResetPassword));
        }, INITIAL_TRACKING_DELAY);
    }, []);
    return (_jsx(Alert, { variant: 'positive', role: 'alert', children: t('loginregistration.login.passwordResetSuccess.content') }));
};
//# sourceMappingURL=PasswordResetSuccessAlert.js.map